import React from 'react';

import styled from 'styled-components';

import Modal from 'components/lib/Modal';
import { CommunityType } from 'types/communities';

import ShopRequestPropagateModalActions from './ShopRequestPropagateModalActions';
import ShopRequestPropagateModalContent from './ShopRequestPropagateModalContent';
import { SHOP_REQUEST_PROPAGATION_MODAL_MODE } from '../constants';

type Props = {
  open: boolean;
  mode: number;
  subtitle?: React.ReactNode;
  baseCommunityId?: number;
  communities: CommunityType[];
  onConfirm?: () => void;
  onCancel: () => void;
};

const ShopRequestPropagateModal = ({
  open,
  mode,
  baseCommunityId,
  subtitle,
  communities,
  onConfirm,
  onCancel,
}: Props) => {
  const propagateTitle = communities?.length > 0 ? `Propagate to (${communities.length})` : 'Propagate to';
  const title = mode === SHOP_REQUEST_PROPAGATION_MODAL_MODE.APPROVE ? 'Approve Shop?' : propagateTitle;

  return (
    <Modal
      className={'compact bare-header flat'}
      open={open}
      onCancel={onCancel}
      footer={null}
      title={title}
      width={540}
    >
      <ShopRequestPropagateModalContent
        mode={mode}
        baseCommunityId={baseCommunityId}
        subtitle={subtitle}
        communities={communities}
      />
      <ShopRequestPropagateModalActions mode={mode} onConfirm={onConfirm} onCancel={onCancel} />
    </Modal>
  );
};

export default ShopRequestPropagateModal;
